<h5 mat-dialog-title class="pb-0">Fissure depth and crown wear</h5>
<hr class="p-0 m-0">
<mat-dialog-content class="mat-typography p-1">
    <div class="m-2 p-2">
        <p>Fissure depth?</p>
        <mat-radio-group [(ngModel)]="q1Value">
            <div class="d-flex justify-content-between">
                <div class="text-center">
                    <p>1. Very deep</p><div><img width="100" height="70" src="f.1.1.svg" /></div>
                    <mat-radio-button value="Very deep"></mat-radio-button>
                </div>
                <div class="text-center">
                    <p>2. Deep (standard)</p><div><img width="100" height="70" src="f.1.2.svg" /></div>
                    <mat-radio-button value="Deep (standard)"></mat-radio-button>
                </div>
                <div class="text-center">
                    <p>3. Slight</p><div><img width="100" height="70" src="f.1.3.svg" /></div>
                    <mat-radio-button value="Slight"></mat-radio-button>
                </div>
                <div class="text-center">
                    <p>4. Very slight</p><div><img width="100" height="70" src="f.1.4.svg" /></div>
                    <mat-radio-button value="Very slight"></mat-radio-button>
                </div>
            </div>
        </mat-radio-group>
        <hr>
        <p>Crown wear?</p>
        <mat-radio-group [(ngModel)]="q2Value">
            <div class="d-flex justify-content-between">
                <div class="text-center">
                    <p>1. No wear</p><div><img width="100" height="80" src="f.2.1.svg" /></div>
                    <mat-radio-button value="No wear"></mat-radio-button>
                </div>
                <div class="text-center">
                    <p>2. Slight wear</p><div><img width="100" height="80" src="f.2.2.svg" /></div>
                    <mat-radio-button value="Slight wear"></mat-radio-button>
                </div>
                <div class="text-center">
                    <p>3. Heavy wear</p><div><img width="100" height="80" src="f.2.3.svg" /></div>
                    <mat-radio-button value="Heavy wear"></mat-radio-button>
                </div>
            </div>
        </mat-radio-group>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button [disabled]="!q1Value || !q2Value" (click)="confirm()">OK</button>
    <button mat-button (click)="cancel()">Cancel</button>
</mat-dialog-actions>